import { XFlex } from '@adornis/chemistry/elements/components/x-flex.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-flex
 */
@customElement('cr-flex')
export class ChromiumFlex extends XFlex {}
